/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
} from '@material-ui/core';

import {
  selectCompanyCode,
  selectReservationCode,
} from '../store/widgetSlice';

import Widget from '../components/common/Widget';
import AddGuestForm from '../components/forms/AddGuestForm';
import api from '../api/widget';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default function WidgetView() {
  const classes = useStyles();
  const companyCode = useSelector(selectCompanyCode);
  const reservationCode = useSelector(selectReservationCode);

  useEffect(() => {
    api.fetchHelloWorld()
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <Box className={classes.root}>
        <p>
          <b>Current Reservation Code:</b>
          {' '}
          <span>{reservationCode}</span>
          {' '}
          <b>Current Company Code:</b>
          {' '}
          <span>{companyCode}</span>
        </p>
      </Box>
      <Widget />
      <Box className={classes.root}>
        <AddGuestForm />
      </Box>
    </>
  );
}
